module.exports = __webpack_public_path__ + "media/en_gb_s3_Oliver.eda3416b.mp3";